// Module
var code = "<div class=\"promo-banner-side-col hide-xs\"><div class=\"promo-banner\"><div compile=\"$ctrl.coopBannerSide.response.detail\"></div></div></div>";
// Exports
module.exports = code;